import React from "react";
import { useStyles } from "./components/materialDesignStyles";
import SideBar from "../SideBar";
import NavBar from "../NavBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import CheckAuthentication from "../CheckAuthentication/CheckAuthentication";

const Layout = (props) => {
  const classes = useStyles();

  const theme = React.useMemo(
    () =>
      createMuiTheme({
        MuiPopover: {
          style: {
            backgroundColor: "#424242",
          },
        },
        palette: {
          type: "dark",
        },
      }),
    []
  );

  return (
    <CheckAuthentication>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className={classes.root}>
          <NavBar />
          <SideBar />
          <main className={classes.content}>{props.children}</main>
        </div>
      </ThemeProvider>
    </CheckAuthentication>
  );
};

export default Layout;
